import styled from 'styled-components'

export const IconContainer = styled.div `
  overflow: auto;
  padding-top: 15px;
`


// WEBPACK FOOTER //
// /src/pages/KontaktStyle.js